module.exports = __webpack_public_path__ + "static/img/tiktok.815b3f0e.png";